import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { IUpdateUserProfileParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useUpdateUserProfile = (options?: UseMutationOptions<any, any, IUpdateUserProfileParams>) => {
  const { userApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: IUpdateUserProfileParams) =>
      userApiService.createCancellableRequest((cancelToken) =>
        userApiService.updateUserProfile(payload, cancelToken)
      ),
    [userApiService]
  );

  const mutation = useMutation<any, any, IUpdateUserProfileParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.USER_PROFILE);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
